<template>
  <div class="illustration-mosaic">
    <div />
    <div />
    <div />
  </div>
</template>

<script>
export default {
  name: 'illustration-mosaic'
}
</script>

<style lang="scss" scoped>
.illustration-mosaic {
  display: inline-flex;
  min-height: 100%;

  div {
    width: 160px;
    margin-right: 16px;
    background: {
      size: 100%;
      repeat: repeat-y;
      position: top;
    }

    &:nth-child(1) {
      background-image: url('~@/assets/login-background-1.png');
    }

    &:nth-child(2) {
      background-image: url('~@/assets/login-background-2.png');
    }

    &:nth-child(3) {
      background-image: url('~@/assets/login-background-3.png');
    }

    &:nth-child(2) {
      @media screen and (max-width: 1000px) {
        display: none;
      }
    }

    &:nth-child(3) {
      @media screen and (max-width: 1280px) {
        display: none;
      }
    }
  }
}
</style>
